import React from "react";

const ExamHeader = ({ timeLeft }) => {
  const formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  };

  return (
    <div className="InterviewHeader CourseBox">
      <h2>Assessment Portal</h2>
      <div className="timer">⏰ {formatTime(timeLeft)}</div>
    </div>
  );
};

export default ExamHeader;